import mainClient from './mainClient';

export {
    mainClient,
};
